import React from "react";

import Grid from "@material-ui/core/Grid";

import RadioQuestion from '../../../question/RadioQuestion';
import DateQuestion from '../../../question/DateQuestion';

const ClientStepV2 = props => {
  const {
    onAnswerChange,
    questions: [
      dataType,
      dataTypeDate
    ],
    dataService
  } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <RadioQuestion
          useCards
          question={dataType}
          onAnswerChange={onAnswerChange}
          replaceComponents={{
            "data_type_date": (
              <span>
                <DateQuestion
                  question={dataTypeDate}
                  onAnswerChange={onAnswerChange}
                />
              </span>
            ),
            "option_1_text": <span><b>Die Angaben</b> der Kunden / Bevollmächtigten / gesetzl. Vertreters <b>vom sind noch aktuell</b> und bilden die Basis für dieses Beratungsgespräch.</span>,
            "option_2_text": <span><b>Die Kundenangaben wurden neu erhoben</b> und bilden die Basis für dieses Beratungsgespräch.Die Angaben werden den Kunden / Bevollmächtigten / gesetzl. Vertreter zusammen mit diesem Protokoll ausgehändigt bzw. übersandt.</span>
          }}
        />
      </Grid>
     </Grid>
  );
};

export default ClientStepV2;
